// Manage redirection depending on calendar type
(function () {
  RootController.$inject = ["$location"];
  angular.module('calendarApp').controller('RootController', RootController);

  function RootController($location) {
    // The customer will be redirected depending on the calendar type chosen by the user
    var calendarType = smooth.calendarSettings.calendartype || 'SERVICE',
        calendarPath = ''; // 1. If the calendar type has been set in the config then that overrrides everything.

    if (calendarType === 'CLASS') {
      return $location.path('/class');
    }

    if (calendarType === 'SERVICE') {
      return $location.path('/service');
    } // If we reach this point then:
    // - The user has been directed to the root url. Their calendar type should have been stored in localStorage,
    //   if not use the service calendar as the default.


    calendarType = localStorage.getItem('calendar-type');

    if (!calendarType) {
      return $location.path('/class');
    }

    switch (calendarType) {
      case 'CLASS':
        return $location.path('/class');

      case 'SERVICE':
        return $location.path('/service');

      default:
        return $location.path('/service');
    }
  }
})();